import { TypesNavigate } from "../../../Configs/Navegacao";

export function isLastSubmenu(sebmenu_list: TypesNavigate, path: string) {

    let removes = (sebmenu_list?.submenu ?? []).filter(item => item.hidden === false);
    let last_item = removes?.[removes?.length - 1]?.path;
    let url = window.location.hostname;

    if (url === 'ttivos.app') {
        let info_usuario_logado = JSON.parse(localStorage.getItem('Itens'));
        let isUsuarioEspecial = info_usuario_logado?.[0]?.cod === 1 || info_usuario_logado?.[0]?.cod === 2 || info_usuario_logado?.[0]?.cod === 112;

        if (isUsuarioEspecial) {
            // Usuários 1, 2 ou 112: dashboard = true, linha-do-tempo = false
            if (path === '/atividades/dashboard') {
                return true;
            }
            if (path === '/atividades/linha-do-tempo') {
                return false;
            }
        } else {
            // Outros usuários: linha-do-tempo = true
            if (path === '/atividades/linha-do-tempo') {
                return true;
            }
        }
    }

    if (path === last_item) {
        return true;
    }
    return false;
}